import { useEffect } from 'react';
import type { OwnerRezWidget } from '@/pages/property-detail/types';

export function useOwnerRezWidgetLoader(propertyName: string, widgets: OwnerRezWidget[]) {
  useEffect(() => {
    if (widgets.length === 0) return;

    const script = document.createElement('script');
    script.src = 'https://app.ownerrez.com/widget.js';
    script.defer = true;
    script.dataset.ownerrezLoader = propertyName;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [propertyName, widgets]);
}
